$('a[href*=\\#]').on('click', function(event){     
    event.preventDefault();
    $('html,body').animate({scrollTop:$(this.hash).offset().top}, 500);
});




$(document).ready(function() {
    

    
/*    var $sticky = $('.gallery');
    var $stickyE = $('.quote');
    var $stickyrStopper = $('.gallery-stop');
      if (!!$sticky.offset()) { // make sure ".sticky" element exists

        var generalSidebarHeight = $sticky.innerHeight();
        var stickyTop = $sticky.offset().top;
        var stickOffset = 0;
        var stickyStopperPosition = $stickyrStopper.offset().top;
        var stopPoint = stickyStopperPosition - generalSidebarHeight - stickOffset;
        var diff = stopPoint + stickOffset;

        $(window).scroll(function(){ // scroll event
            var windowTop = $(window).scrollTop(); // returns number

            if (stopPoint < windowTop) {
              $stickyE.css({ position: 'fixed', bottom: 'bottom', top: '0', opacity: '1' });
                
            } else if (stickyTop < windowTop+stickOffset) {
              $stickyE.css({ position: 'fixed', top: stickOffset, opacity: '1' });
            } else {
              $stickyE.css({position: 'fixed', top: 'initial',bottom:'auto', opacity: '0'});
            }
            
            
        });

        }*/

    /*var quote = $('.quote h4 > span');

                var timelineQuote = new TimelineMax({ paused: true, reversed: false });
                timelineQuote.staggerFromTo(quote, 1, {css:{opacity:0, y:50} }, {css:{opacity:1, y:0, } }, 0.04, 0);

                timelineQuote.play();*/
    
});

     


// Hide Header on on scroll down
var didScroll;
var lastScrollTop = 0;
var delta = 5;
var navbarHeight = $('header').outerHeight();

$(window).scroll(function(event){
    didScroll = true;
});

setInterval(function() {
    if (didScroll) {
        hasScrolled();
        didScroll = false;
    }
}, 250);

function hasScrolled() {
    var st = $(this).scrollTop();
    
    // Make sure they scroll more than delta
    if(Math.abs(lastScrollTop - st) <= delta)
        return;
    
    // If they scrolled down and are past the navbar, add class .nav-up.
    // This is necessary so you never see what is "behind" the navbar.
    if (st > lastScrollTop && st > navbarHeight){
        // Scroll Down
        $('.header').removeClass('black').addClass('transparent');
        $('.logos a').removeClass('show').addClass('hide');
        $('.logo a').removeClass('show').addClass('hide');
    } else {
        // Scroll Up
        if(st + $(window).height() < $(document).height()) {
            $('.header').removeClass('transparent').addClass('black');
            $('.logos a').removeClass('hide').addClass('show');
            $('.logo a').removeClass('hide').addClass('show');
        }
    }
    
    lastScrollTop = st;
}